import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {
    AiSetupAcceptRequest,
    AiSetupJobDetail,
    AiSetupJobInfo,
    AiSetupRequest
} from "../../fund/generated-sources/api";

export const FundAiSetupActions = createActionGroup({
    source: "Fund AI Setup",
    events: {
        // Start
        start: props<{ fundId: number; request: AiSetupRequest }>(),
        startSuccess: props<{ fundId: number; taskInfoId: number }>(),
        startError: props<{ fundId: number; errorMsg: string }>(),

        // List jobs (per fund) + polling
        loadJobs: props<{ fundId: number }>(),
        loadJobsSuccess: props<{ fundId: number; jobs: AiSetupJobInfo[] }>(),
        loadJobsError: props<{ fundId: number; errorMsg: string }>(),

        // Detail (viewer)
        loadDetail: props<{ taskInfoId: number }>(),
        loadDetailSuccess: props<{ detail: AiSetupJobDetail }>(),
        loadDetailError: props<{ errorMsg: string }>(),

        // Accept / skip per result
        acceptResult: props<{ resultId: number; request: AiSetupAcceptRequest; taskInfoId: number }>(),
        acceptResultSuccess: props<{ resultId: number; taskInfoId: number }>(),
        acceptResultError: props<{ resultId: number; errorMsg: string }>(),

        skipResult: props<{ resultId: number; taskInfoId: number }>(),
        skipResultSuccess: props<{ resultId: number; taskInfoId: number }>(),
        skipResultError: props<{ resultId: number; errorMsg: string }>(),

        clearError: emptyProps()
    }
});
